import { __ } from "@wordpress/i18n";
import React, { useEffect, useState } from 'react';
import apiFetch from "@wordpress/api-fetch";
import Hint from '../components/Hint/Hint';
import Switch from '../components/Switch/Switch';
import TagInput from '../components/TagInput/TagInput';
import InputBox from '../components/InputBox/InputBox';
import { useMenu } from '../contexts/MenuContext';
import withForm from '../pages/withForm';
const SecurityLoginLimit = ({handleChange}) => {
    const {
        settingData
    } = useMenu();
    // console.log(settingData.security.login_limit);
    const [recoveryUrl, setRecoveryUrl] = useState('');
    const [copied, setCopied] = useState(false);    
    const [clicked, setClicked] = useState(false);

    const generateRecoveryKey = async () => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let key = '';
        for (let i = 0; i < 32; i++) {
            key += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        const newRecoveryUrl = ultimate_security_ajax_obj.site_url + "/login/?key=" + key;
        
        // Set state first
        setRecoveryUrl(newRecoveryUrl);
        
        // Then save the URL
        await saveRecoveryUrl(newRecoveryUrl);
    }
    
    const saveRecoveryUrl = async (recovery_url) => {
        try {
            const response = await apiFetch({
                path: '/ultimate-security/v1/save-recovery-url',
                method: 'POST',
                data: {
                    recovery_url: recovery_url,
                    _wpnonce: ultimate_security_ajax_obj.security
                }
            });
            console.log("Recovery URL saved successfully:", response);
        } catch (error) {
            console.error("Error saving recovery URL:", error); 
        }
    }
    
    const copyToClipboard = async () => {
        // Get the current value to copy (either from state or from settings)
        const valueToCopy = settingData?.security?.login_limit?.recovery_url || recoveryUrl;
        
        if (!valueToCopy) {
            console.log("No recovery URL to copy");
            return;
        }
        
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(valueToCopy);
            } else {
                const textarea = document.createElement("textarea");
                textarea.value = valueToCopy;
                textarea.style.position = "fixed"; // avoid scrolling to bottom
                textarea.style.opacity = 0;
                document.body.appendChild(textarea);
                textarea.focus();
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);
            }

            setCopied(true);
            setClicked(true);
            setTimeout(() => setCopied(false), 1500);
            setTimeout(() => setClicked(false), 200);
        } catch (err) {
            console.error("Copy failed", err);
        }
    };
             
    

    return (
        <>
            <div className="setting-unit mb-lg">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Login Limit", "ultimate-security")}</h5>
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint content={__("Enable login limit.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("Enable", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.login_limit.enable"
                                    checked={settingData?.security?.login_limit?.enable} // Pass "1"/"0" from API 
                                    onChange={handleChange} 
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${settingData?.security?.login_limit?.enable !== "1" ? 'deactive-section' : ''}`}>
                <div className="setting-unit mb-lg">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="title-group">
                                <h5 className="pl-heading-1 fw-600 text-text">{__("Login Attempts", "ultimate-security")}</h5>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="row justify-content-between">
                                <div className="col-lg-10">
                                    <div className="number-group d-flex align-items-center gap-2">
                                        <Hint position="top" content={__("Set the number of login attempts allowed.", "ultimate-security")}/>                                    
                                        <InputBox
                                            name="security.login_limit.login_attempts"
                                            type="number"
                                            min={1}
                                            decimalAllowed={false}
                                            placeholder="4"
                                            value={settingData?.security?.login_limit?.login_attempts}
                                            handleChange={handleChange}
                                        />
                                        <p className="pl-body text-text mb-0">{__("Login retries before locked out.", "ultimate-security")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="setting-unit mb-lg">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="title-group">
                                <h5 className="pl-heading-1 fw-600 text-text">{__("Lockout Duration", "ultimate-security")}</h5>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="row justify-content-between">
                                <div className="col-lg-10">
                                    <div className="number-group d-flex align-items-center gap-2">
                                        <Hint position="top" content={__("Set the lockout minutes", "ultimate-security")}/>                                    
                                        <InputBox
                                            name="security.login_limit.lockout_duration"
                                            type="number"
                                            min={1}
                                            decimalAllowed={false}
                                            placeholder="10"
                                            value={settingData?.security?.login_limit?.lockout_duration}
                                            handleChange={handleChange}
                                        />
                                        <p className="pl-body text-text mb-0">{__("Lockout for a minutes.", "ultimate-security")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="setting-unit mb-lg">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="title-group">
                                <h5 className="pl-heading-1 fw-600 text-text">{__("Increase Login attempts", "ultimate-security")}</h5>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="row justify-content-between">
                                <div className="col-lg-10">
                                    <div className="number-group d-flex align-items-center gap-2">
                                        <Hint position="top" content={__("Set the number of login attempts allowed.", "ultimate-security")}/>                                    
                                        <InputBox
                                            name="security.login_limit.increase_login_attempts"
                                            type="number"
                                            min={1}
                                            decimalAllowed={false}
                                            placeholder="4"
                                            value={settingData?.security?.login_limit?.increase_login_attempts}
                                            handleChange={handleChange}
                                        />
                                        <p className="pl-body text-text mb-0">{__("Increase login retries after first locked out.", "ultimate-security")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="setting-unit mb-lg">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="title-group">
                                <h5 className="pl-heading-1 fw-600 text-text">{__("Increase Lockout Duration", "ultimate-security")}</h5>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="row justify-content-between">
                                <div className="col-lg-10">
                                    <div className="number-group d-flex align-items-center gap-2">
                                        <Hint position="top" content={__("Set the number of Increase Lockout Duration allowed.", "ultimate-security")}/>                                    
                                        <InputBox
                                            name="security.login_limit.increase_lockout_duration"
                                            type="number"
                                            min={1}
                                            max={60}
                                            step={1}
                                            decimalAllowed={false}
                                            placeholder="12"
                                            value={settingData?.security?.login_limit?.increase_lockout_duration}
                                            handleChange={handleChange}
                                        />
                                        <p className="pl-body text-text mb-0">{__("Increase Lockout time in hours after first locked out.", "ultimate-security")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="setting-unit mb-lg">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="title-group">
                                <h5 className="pl-heading-1 fw-600 text-text">{__("Retries Reset Duration", "ultimate-security")}</h5>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="row justify-content-between">
                                <div className="col-lg-10">
                                    <div className="number-group d-flex align-items-center gap-2">
                                        <Hint position="top" content={__("Lockouts hours until retries are reset.", "ultimate-security")}/>                                    
                                        <InputBox
                                            name="security.login_limit.retries_reset_duration"
                                            type="number"
                                            min={1}
                                            max={24}
                                            step={1}
                                            placeholder="12"
                                            decimalAllowed={false}
                                            value={settingData?.security?.login_limit?.retries_reset_duration}
                                            handleChange={handleChange}
                                        />
                                        <p className="pl-body text-text mb-0">{__("Lockouts hours until retries are reset.", "ultimate-security")}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="setting-unit mb-lg">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="title-group">
                                <h5 className="pl-heading-1 fw-600 text-text">{__("Block Users", "ultimate-security")}</h5>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="row justify-content-between">
                                <div className="col-lg-10">
                                    <div className="title-group d-flex align-items-center">
                                        <Hint position="top" content={__("Block Users", "ultimate-security")}/>                                    
                                        <TagInput 
                                            name='security.login_limit.block_users' 
                                            type='username' 
                                            initialTags={settingData?.security?.login_limit?.block_users} 
                                            handleChange={handleChange} 
                                            whitelist={ultimate_security_ajax_obj.usersList}
                                        />
                                    </div>  
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="setting-unit mb-lg">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="title-group">
                                <h5 className="pl-heading-1 fw-600 text-text">{__("Recovery URL", "ultimate-security")}</h5>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="row justify-content-between">
                                <div className="col-lg-10">
                                    <div className="title-group d-flex align-items-center">
                                        <Hint position="top" content={__("Add Recovery URL", "ultimate-security")}/>                                    
                                        <input 
                                            type="text" 
                                            value={recoveryUrl==="" ? settingData?.security?.login_limit?.recovery_url : recoveryUrl} 
                                            name="recovery_url" 
                                            readOnly
                                        />                                    
                                    </div>
                                    <div className="col-auto mt-3 d-flex gap-2" style={{marginLeft: "26px"}}>
                                        <button 
                                            type="button" 
                                            className="button button-secondary" 
                                            onClick={generateRecoveryKey} 
                                        >
                                            {__("Generate Key", "ultimate-security")}
                                        </button>
                                        <button
                                            type="button"
                                            className="button button-secondary px-3 py-1 bg-gray-200 rounded flex items-center"
                                            onClick={copyToClipboard}
                                            title={copied ? "Copied!" : "Copy"}
                                        >
                                            <span
                                                className={`dashicons dashicons-clipboard ${clicked ? "icon-clicked" : ""}`}
                                                style={{
                                                    cursor: "pointer",
                                                    fontSize: "20px",
                                                    color: "#873eff",
                                                    transition: "transform 0.2s"
                                                }}
                                            >
                                            </span>
                                        </button>

                                        {copied && (
                                            <div className="mt-2 text-green-600">{__("Copied to clipboard!", "ultimate-security")}</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(SecurityLoginLimit,'security.login_limit');